import React, { useEffect, useRef } from "react";

// Lazy load leaflet CSS once
let _cssLoaded = false;
function ensureLeafletCss() {
  if (_cssLoaded) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.css";
  link.integrity = "sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=";
  link.crossOrigin = "";
  document.head.appendChild(link);
  _cssLoaded = true;
}

/**
 * Mini read-only map preview.
 * Props: lat, lng, height (px), zoom
 */
export default function MapPreview({ lat, lng, height = 160, zoom = 14 }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    ensureLeafletCss();
    let cancelled = false;
    (async () => {
      const L = (await import("leaflet")).default;
      if (cancelled || !ref.current) return;
      if (!mapRef.current) {
        mapRef.current = L.map(ref.current, {
          zoomControl: false,
          attributionControl: false,
          dragging: false,
          touchZoom: false,
          scrollWheelZoom: false,
          doubleClickZoom: false,
        }).setView([lat, lng], zoom);
        L.tileLayer("https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png", {
          maxZoom: 19,
        }).addTo(mapRef.current);
        const icon = L.divIcon({
          className: "",
          html: `<div style="width:14px;height:14px;background:#3B82F6;border:2px solid #000;box-shadow:0 0 12px #3B82F6;border-radius:50%"></div>`,
        });
        L.marker([lat, lng], { icon }).addTo(mapRef.current);
      } else {
        mapRef.current.setView([lat, lng], zoom);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [lat, lng, zoom]);

  return (
    <div
      ref={ref}
      style={{ height, width: "100%" }}
      className="border border-white/10 overflow-hidden bg-[#0A1628]"
      data-testid="map-preview"
    />
  );
}
